module.exports = __webpack_public_path__ + "static/img/m_role.af254e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/oo/m_role.png
// module id = TKFx
// module chunks = 7